import {Publisher} from '../../shared/domain/publisher.model';
import {ContentOwner} from '../../shared/domain/content-owner.model';
import {Network} from 'src/app/shared/domain/network.model';
import {KeyLabel} from '../../shared/domain/key-label.model';

export class User {
  id?: string;
  accessToken?: string;
  username?: string;
  email: string;
  name: string;
  publisherIds: string[];
  publishers: Publisher[];
  roles: string[];
  password: string;
  createdOn: string;
  lastUpdatedOn: string;
  extPublisherNames: string;
  contentOwnerIds?: string[];
  advertiserIds?: string[];
  enabled?: boolean;
  contentOwners?: ContentOwner[];
  network?: Network;
}

export class ChangePasswordRequest {
  username: string;
  oldPassword: string;
  newPassword: string;
}

export class UpdateProfileRequest {
  name: string;
  username: string;
}

export const UsersStatusKL = () =>
  Object.keys(UsersStatus).map(
    (key) => new KeyLabel(key as UsersStatus, UsersStatusLabels[key])
  );

export class UsersStatusBox {
  count: number;
  status: string;
}

export enum UsersStatus {
  enabled = 'ENABLED',
  disabled = 'DISABLED',
}

export const UsersStatusLabels = {
  enabled: 'Active',
  disabled: 'Archived',
};

export enum UsersStatusColorMap {
  enabled = 'green',
  disabled = 'gray',
}
